export enum ZINDEX {
  NavBar = 20,
  CartSidebar = 21,
}
